import { render } from "./crypto.vue?vue&type=template&id=ea84fc78"
import script from "./crypto.vue?vue&type=script&lang=js"
export * from "./crypto.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/appitoc/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__